import type { ReactNode } from 'react'
import { Link } from 'react-router'
import type { CrmContactDetail } from '../types'

/**
 * A person who is not (or no longer) a CRM contact (spec-63 E3, the point spec-59 deferred):
 * a founder from ⌘K or an old bookmark. No editing and no quick actions, only the way to
 * the startup dossier the person belongs to.
 */
export function NoRelation({ detail, back }: { detail: CrmContactDetail; back: ReactNode }) {
  const dossier = detail.startup_links.find((link) => link.deal_id)
  return (
    <div className="flex flex-col gap-4">
      {back}
      <section aria-label="Geen relatie" className="vonk-card flex flex-col gap-3 p-6">
        <h1 className="font-heading text-xl font-semibold break-words">{detail.full_name}</h1>
        <p className="font-semibold">Geen relatie</p>
        <p className="text-sm text-muted-foreground">
          Deze persoon staat niet in het CRM. Founders en andere personen van het platform horen bij
          hun startup-dossier, niet bij Relaties.
        </p>
        {dossier ? (
          <Link
            to={`/preinvest/deals/${dossier.deal_id}`}
            className="self-start text-sm font-medium text-primary hover:underline max-md:flex max-md:min-h-11 max-md:items-center"
          >
            Naar het dossier van {dossier.name} →
          </Link>
        ) : null}
      </section>
    </div>
  )
}
